module.exports = __webpack_public_path__ + "img/route.6fe60a52.svg";